import { QueryClient } from '@tanstack/react-query'
import { shouldRetryQuery } from './queryRetry'

/** Refine's key for `useIsAuthenticated` (the `<Authenticated>` check). */
export const AUTH_CHECK_QUERY_KEY = ['auth', 'check'] as const

/**
 * The query client shared by Refine and the custom screens. Refine's
 * `<Authenticated>` renders nothing while its session check is fetching, so a
 * refetch on window focus would unmount the whole app and lose every unsaved
 * form. The session is still checked on load, and an expired one surfaces as
 * a 401 from the API (`authProvider.onError`).
 */
export function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { retry: shouldRetryQuery } },
  })
  queryClient.setQueryDefaults([...AUTH_CHECK_QUERY_KEY], {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
  return queryClient
}
